"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ArrowIcon = function ArrowIcon() {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      width: "15px",
      height: "15px",
      viewBox: "0 0 15 15"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      stroke: "none",
      strokeWidth: "1",
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    _react["default"].createElement("path", {
      d: "M8,2 L7.99989322,8.585 L11.2928932,5.29289322 L12.7071068,6.70710678 L7,12.4142136 L1.29289322,6.70710678 L2.70710678,5.29289322 L5.99989322,8.585 L6,2 L8,2 Z",
      fillRule: "nonzero"
    })))
  );
};

var _default = ArrowIcon;
exports["default"] = _default;